// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__1_fKL"};